import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop" warning (fired by some Radix UI components)
// so it never surfaces as a runtime-error overlay.
const RESIZE_OBSERVER_ERR = /ResizeObserver loop (limit exceeded|completed)/;
window.addEventListener("error", (e) => {
  if (e?.message && RESIZE_OBSERVER_ERR.test(e.message)) {
    e.stopImmediatePropagation();
  }
});


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
